import { View, StyleSheet } from 'react-native';
import { EditableList, Text, theme } from '@socrait/react';

type VoiceNameListProps = {
  studentList: {
    id: string;
    voiceName: string;
  }[];
  setStudentList: (items: { id: string; voiceName: string }[]) => void;
  duplicateName?: string;
};

export const VoiceNameList = ({ studentList, setStudentList, duplicateName }: VoiceNameListProps) => {
  const listHeader = (
    <Text style={styles.listHeader}>
      {studentList.length} Voice Name{studentList.length === 1 ? '' : 's'} added
    </Text>
  );

  return (
    <View style={styles.voiceNameListContainer}>
      <EditableList
        items={studentList}
        setItems={setStudentList}
        errorLabel={duplicateName}
        labelField="voiceName"
        canDeleteItems={true}
        header={listHeader}
        listStyle={styles.list}
      />

      {!studentList.length && (
        <View style={styles.noVoiceNames}>
          <Text style={[styles.noVoiceNameText, styles.noVoiceNameHeader]}>There's nothing here yet!</Text>
          <Text style={styles.noVoiceNameText}>
            You need to add at least one voice name in order to save this class.
          </Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  voiceNameListContainer: {
    flex: 1,
  },
  list: {
    flexGrow: 0,
  },
  listHeader: {
    backgroundColor: theme.colors.white,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeights.bold,
    paddingBottom: theme.spacing.large,
  },
  noVoiceNames: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.medium,
    marginTop: theme.spacing.xlarge,
  },
  noVoiceNameHeader: {
    fontSize: theme.fontSizes.large,
  },
  noVoiceNameText: {
    color: theme.colors.darkGray,
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.medium,
    textAlign: 'center',
  },
});
